/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { get } from 'lodash'

function SEO({ description, lang, meta, title, coverImage, slug, icon }) {
    const { wagtail } = useStaticQuery(
        graphql`
            query {
                wagtail {
                    socialSettings: setting(name: "SocialMediaSettings") {
                        ... on SocialMediaSettings {
                            siteName
                            defaultSharingText
                            twitterHandle
                            facebookAppId
                        }
                    }
                }
            }
        `,
    )

    const metaDescription = description
    const twitterHandle = get(wagtail, 'socialSettings.twitterHandle', '')

    return (
        <Helmet
            title={title}
            htmlAttributes={{
                lang,
            }}
            link={[
                {
                    rel: 'manifest',
                    href: `/${slug}-manifest.json`,
                },
                {
                    rel: 'apple-touch-icon',
                    href: icon,
                },
            ]}
            meta={[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:image`,
                    content: coverImage.src,
                },
                {
                    property: `og:image:width`,
                    content: coverImage.width,
                },
                {
                    property: `og:image:height`,
                    content: coverImage.height,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: twitterHandle,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
                {
                    name: `twitter:image`,
                    content: coverImage.src,
                },
            ].concat(meta)}
        />
    )
}

SEO.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
    coverImage: ``,
}

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default SEO
